import { useLocation } from 'react-router'
import { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { useAnalytics } from '@praxis/analytics/client'
import { logEvent } from '@praxis/component-logging'
import { Card, Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { SectionHeader } from '../globalComponents/SectionHeader'
import apiConfig from '../globalConfig/apiConfig'
import {
  CUSTOM_ANALYTICS_TYPES,
  CUSTOM_ANALYTICS_EVENT_NAMES,
} from '../globalConfig/constants'

export const UnauthorizedPage = () => {
  const location = useLocation()
  const auth = useAuth()
  const userLanId = auth?.session?.userInfo?.lanId
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    logEvent(
      {
        message:
          auth?.session?.userInfo?.fullName +
          ' (' +
          auth?.session?.userInfo?.lanId +
          ') was denied access to resource at: ' +
          location.pathname,
      },
      apiConfig?.logging,
    )
    sendEvent({
      event: {
        type: CUSTOM_ANALYTICS_TYPES.ACCESS_DENIED,
        id: CUSTOM_ANALYTICS_EVENT_NAMES.ACCESS_DENIED,
        value: location.pathname,
      },
      client: {
        employee_login_id: userLanId,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth?.session?.userInfo?.fullName,
    auth?.session?.userInfo?.lanId,
    location,
    userLanId,
  ])

  return (
    <>
      <SectionHeader
        className="hesp-sectionHeader-layout"
        pageHeading="Unauthorized Resource"
      />
      <Layout.Body
        className="hesp-generic-layout"
        data-testid="layoutWithUnauthorizedPageContent"
        includeRail
      >
        <Card className="hc-pa-normal">
          <Grid.Container>
            <Grid.Item className="hesp-general-fullwidth">
              <p>Your account is not authorized to access this resource.</p>
            </Grid.Item>
          </Grid.Container>
        </Card>
      </Layout.Body>
    </>
  )
}
